export function isKefuRechargePage(appInfo) {
  return Number(appInfo && appInfo.recharge_kefu_page) === 1;
}

export function getDepositPath(appInfo) {
  return isKefuRechargePage(appInfo) ? '/rechargeKefu' : '/recharge';
}

export function isDepositTabPath(path) {
  return path === '/recharge' || path === '/rechargeKefu';
}



// WEBPACK FOOTER //
// ./src/utils/deposit.js